import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

/*
 * «Зведений командний / клубний рейтинг» — the ratings of the competitions
 * held together: the same city, overlapping dates, the same discipline
 * (ConsolidatedStandings, 12 Oct 2026).
 */

/**
 * The competitions this one consolidates with, itself included — the
 * backend's answer, never re-derived here. Resolves [] when it cannot be read,
 * so the two rows are left out rather than offered wrong.
 */
export const fetchConsolidatedCompetitions = competition => () =>
    axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_CONSOLIDATED, null, { params: { competition } }))
        .then(transformHttpResponse)
        .then(response => (response.data && response.data.competitions) || [])
        .catch(() => []);

/**
 * `kind`: 'team' (regions) or 'club'; `ids`: the competitions ticked (absent
 * — all); `showHeadClub`: «Показувати головний клуб» (14 Oct 2026).
 */
export const fetchConsolidatedRanksReport = (competition, kind, ids, showHeadClub = false) => dispatch =>
    axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_CONSOLIDATED_RANKS, {
        ...(ids ? { ids: ids.join(',') } : {}),
        ...(showHeadClub ? { headClub: 1 } : {}),
    }, {
        params: { competition, kind },
        isBlob: true,
    }))
        .then(transformHttpResponse)
        .then(response => {
            const contentDisposition = response.headers['content-disposition'] || '';
            const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
            download(response.data, filenameMatch ? filenameMatch[1] : 'report.pdf', response.headers['content-type']);
        })
        .catch(error => transformHttpResponse(error.response))
        .catch(error => dispatch(errorRequestHandler(error)));
